
export const SITE_NAME = "Ruudev";
export const SITE_URL = "https://www.ruudev.com/";
export const BANNER_SITE_URL = "https://ruuban.com/";

